import type { InstallerUploadResult, ReaderVersion } from '../types';

/**
 * Phần mô tả file cài đi kèm khi lưu một phiên bản.
 *
 * Ba trường này chỉ có nghĩa khi `download_url` vẫn đúng là file vừa upload.
 * Dán một link khác mà giữ checksum cũ thì app tải bản mới về, thấy checksum
 * lệch và từ chối cài — hỏng luồng cập nhật của cả kênh đó.
 */
export interface InstallerPayload {
  file_name: string | null;
  file_size: number | null;
  file_checksum: string | null;
}

/**
 * Trả `null` chứ KHÔNG trả `undefined` cho trường hợp phải xoá.
 *
 * JSON.stringify bỏ hẳn khoá mang giá trị undefined, nên server không nhận
 * được gì để xoá và giá trị cũ nằm nguyên cạnh một download_url mới — đúng
 * thứ hàm này sinh ra để ngăn.
 *
 * Sửa một bản ghi mà không upload lại (bật "Bắt buộc", điền release notes...)
 * thì `existing` vẫn trỏ đúng file đang phát hành: giữ nguyên mô tả của nó.
 * Gửi null ở đây là xoá mất checksum, và app bỏ qua mọi bản cập nhật không
 * có sha256 — cả kênh đó ngừng tự cập nhật mà không báo lỗi gì.
 */
export const buildInstallerPayload = (
  uploaded: InstallerUploadResult | null,
  downloadUrl: string,
  existing?: Pick<ReaderVersion, 'download_url' | 'file_name' | 'file_size' | 'file_checksum'> | null
): InstallerPayload => {
  if (uploaded && downloadUrl === uploaded.url) {
    return {
      file_name: uploaded.file_name,
      file_size: uploaded.size,
      file_checksum: uploaded.file_checksum,
    };
  }

  if (existing?.download_url && downloadUrl === existing.download_url) {
    return {
      file_name: existing.file_name ?? null,
      file_size: existing.file_size ?? null,
      file_checksum: existing.file_checksum ?? null,
    };
  }

  return { file_name: null, file_size: null, file_checksum: null };
};
